// extracted by mini-css-extract-plugin
module.exports = {"section":"VrmSection_section__ZLPoi","left":"VrmSection_left__XeeOt","right":"VrmSection_right__xnUoR","link":"VrmSection_link__tFFda","text":"VrmSection_text__k5qyK"};